import { render } from "./Buildings.vue?vue&type=template&id=e4da26c4"
import script from "./Buildings.vue?vue&type=script&lang=js"
export * from "./Buildings.vue?vue&type=script&lang=js"
script.render = render

export default script